export default __webpack_public_path__ + "static/media/apps.09225d5f.svg";